import axios from "axios";
import { $SERVER } from "../_const/_const";

function authHeaders() {
  const token = localStorage.getItem("token-1755");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Public — enregistre 1 visite unique par appareil par jour.
export async function recordVisit(sessionId, lang) {
  await axios.post(`${$SERVER}/api/stats/visit`, { sessionId, lang });
}

// Public — déclare le genre du visiteur du jour.
export async function declareVisitGender(sessionId, gender) {
  await axios.post(`${$SERVER}/api/stats/visit/${sessionId}/gender`, { gender });
}

// Admin — agrégations pour la page stats.
export async function fetchSummary() {
  const res = await axios.get(`${$SERVER}/api/stats/summary`, {
    headers: authHeaders(),
  });
  return res.data?.data;
}
